const SHOW_ERRORS = {
  // Aborts
  ['304001']:'ErrorPage',
  ['304002']:'ErrorPage',
  ['304003']:'ErrorPage',
  ['304004']:'ErrorPage',
  ['304005']:'ErrorPage',
  ['304006']:'ErrorPage',
  ['304007']:'ErrorModalPayment',
  ['304008']:'ErrorPage',
  ['304009']:'ErrorPage',
  ['304010']:'ErrorPage',
  ['304011']:'ErrorPage',
  ['304012']:'ErrorModalPayment',
  ['304013']:'ErrorPage',
  ['304014']:'ErrorPage',
  ['304015']:'ErrorPage',
  ['304016']:'ErrorPage',
  ['304017']:'ErrorPage',
  ['304018']:'ErrorPage',
  ['304019']:'ErrorPage',
  ['304020']:'ErrorPage',
  ['304021']:'ErrorPage',
  ['304022']:'ErrorPage',
  ['304023']:'ErrorPage',
  ['304024']:'ErrorPage',
  ['304025']:'ErrorPage',
  ['304026']:'ErrorPage',
  ['304027']:'ErrorPage',
  ['304028']:'ErrorPage',
  ['304029']:'ErrorPage',
  ['304030']:'ErrorPage',
  ['304031']:'ErrorPage',
  ['304032']:'ErrorPage',
  ['304033']:'ErrorPage',
  ['304034']:'ErrorPage',
  ['304035']:'ErrorPage',
  ['304036']:'ErrorPage',
  ['304037']:'ErrorPage',
  ['304038']:'ErrorPage',
  ['304039']:'ErrorPage',
  ['304040']:'ErrorPage',
  ['304041']:'ErrorPage',
  // PNR not found
  ['302049']:'ErrorModal',
  // Fix
  ['302002']:'ErrorBanner',
  ['302003']:'ErrorBanner',
  ['302004']:'ErrorBanner',
  ['302005']:'ErrorBanner',
  ['302006']:'ErrorBanner',
  ['302007']:'ErrorBanner',
  ['302008']:'ErrorBanner',
  ['302009']:'ErrorBanner',
  ['302030']:'ErrorBanner',
  ['302040']:'ErrorBanner',
  ['302041']:'ErrorModalPayment',
  ['204128']:'ErrorModal',
  ['302046']:'ErrorBanner',
  ['302047']:'ErrorBanner',
  ['302048']:'ErrorBanner',
  ['302050']:'ErrorModal', // pnr
  ['202001']:'ErrorBanner', // emd send email null
  ['302051']:'ErrorBanner',
  ['302052']:'ErrorBanner',
  ['302053']:'ErrorBanner',
  // Seatmaps
  ['100412']:'ErrorBanner',
  // Special errors - Modal error pago
  ['302045']:'ErrorModalPayment',
  ['302042']:'ErrorModalPayment',
  ['302043']:'ErrorModalPayment',
  ['302044']:'ErrorModalPayment',
  ['100213']:'ErrorModalPayment', // error cybersource
  ['13422301']:'ErrorModal', // error cybersource
  ['305010']:'ErrorPage',
  ['13430301']: 'ErrorModalPayment',
  ['13530303']: 'ErrorModalPaymentLimit', // error limite de pagos
  ['13110309']: 'ErrorModalPaymentFare', // error tarifa no disponible
  ['13111801']: 'ErrorPage',
  ['13111802']: 'ErrorPage',
  // errores desconexión
  ['13110304']: 'ErrorModal',
  ['13110305']: 'ErrorModal',
  ['15111801']: 'ErrorModal',
  ['15111802']: 'ErrorModal',
  ['15111803']: 'ErrorModal',
  ['13330301']: 'ErrorModal',
  ['13330302']: 'ErrorModal',
  // Errores pago puntos premier
  ['13330701']: 'ErrorModalTotem',
  ['13430701']: 'ErrorModalTotem',
  ['13111321']: 'ErrorModalTotem',
  // Errores de upgrade
  ['13110306']: 'ErrorModal',
  ['13110307']: 'ErrorModal',
  ['13110308']: 'ErrorModal',
  // Error cargo sin emisión
  ['13111332']: 'ErrorNonEmissionChargeModal',

  // Error redirect storefront
  ['305005']: 'ErrorPage',

  // Error FFNASSOCIATION
  ['ERR.UB.FFNASSOCIATION.INVALID_DATA']: 'ErrorBanner',

  // Errores microservicios AWS (userExperiencie)
  ['abortBanner']: 'ErrorBanner',    // banner rojo toast
  ['abortModal']: 'ErrorModal',      // modal amarillo
  ['abortScreen']: 'ErrorUI',        // pantalla azul
  ['continueModaltoHome']: 'ErrorModal', // ?
  ['customBanner']: 'ErrorCustomBanner',  // ?
  ['noneAction']: null,
  ['sucessBanner']: 'ErrorModal',     // ?
  ['warningBanner']: 'warningBanner', // ?

  // Error default
  null: 'ErrorPage',
  undefined: 'ErrorPage',
  false: 'ErrorPage',
};

export default SHOW_ERRORS;
